import React from 'react'

import FlyerTreeHeader from './components/FlyerTreeHeader'
import FlyerGridMenu from './components/FlyerGridMenu'
import FlyerGridBody from './components/FlyerGridBody'

// !FIXME - Hard - Reduce gravity of this prop flow and connect redux at lower levels

const FlyerGridView = ({
  flyers,
  resource,
  resourceId,
  resourceName,
  flyerId,
  viewOptions,
  categoryOptions,
  sortOptions,
  currentSortOption,
  handleFlyerSortChange,
  currentCategory,
  handleCategoryChange,
  setCategoryFilter,
  coBrandingUrl,
  coBrandingAlt,
  coBrandingLogoLink,
  sheetsSaved,
  treesSaved,
  disclaimer,
  districtError,
  schoolError,
  lastUpdated,
  districtId,
  handleMetricClick,
  showCounters
}) => (
  <React.Fragment>
    <FlyerTreeHeader
      header={resourceName}
      sheetsSaved={sheetsSaved}
      treesSaved={treesSaved}
      showCounters={showCounters}
      coBrandingAlt={coBrandingAlt}
      coBrandingUrl={coBrandingUrl}
      coBrandingLogoLink={coBrandingLogoLink}
    />
    <FlyerGridMenu
      resource={resource}
      resourceId={resourceId}
      viewOptions={viewOptions}
      categoryOptions={categoryOptions}
      sortOptions={sortOptions}
      handleCategoryChange={handleCategoryChange}
      handleFlyerSortChange={handleFlyerSortChange}
      currentCategory={currentCategory}
      currentSortOption={currentSortOption}
    />
    <FlyerGridBody
      flyers={flyers}
      resource={resource}
      resourceId={resourceId}
      flyerId={flyerId}
      districtError={districtError}
      schoolError={schoolError}
      lastUpdated={lastUpdated}
      currentCategory={currentCategory}
      setCategoryFilter={setCategoryFilter}
      districtId={districtId}
      handleMetricClick={handleMetricClick}
      disclaimer={disclaimer}
    />
  </React.Fragment>
)

export default FlyerGridView



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/FlyerGrid.js